
import { AfterContentChecked, ChangeDetectorRef, Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
//import { Hub, HubManager } from 'src/app/pages/hubs/common/Hubs';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
/*import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';*/
declare var $: any;
var dataQueueInfo: any = {};
let inboundCheckPaused = false,
	queues = null,
	curQueue = null,
	navigateURL = null,
	lastParams = null,
	curQueueDisplayType = null,// Queue.QUEUE_TYPE_ALL,
	recordLocks,
	reloading = null,
	lockCheckPaused = false;
@Injectable({ providedIn: 'root' })
export class Queue {
	static QUEUE_TYPE_ALL: string = 'queueControllerQueueTypeAll';
	constructor(private tmQueueService: TmQueueService) {




	}
	//index = function (mapping) {
	curQueueDisplayType = Queue.QUEUE_TYPE_ALL;
	inboundCheckPaused = false;
	lockCheckPaused = false;

	//cls.QBRSecurity().setServerSyncProp('RecordLock', null);
	//cls.QBRSecurity().setServerSyncProp('CaseLocks', null);
	//dataService.ReleaseLocks();
	//cls.cl().main().mainController().lockStatus(false);
	call = function (queueid) {
		navigateURL = '';
		dataQueueInfo = null;
		curQueue = null;
		//var id = mapping.id.length ? mapping.id[0] : null;
		//var id = queueid.length ? queueid : queueid;
		var id = queueid;

		//this.getqueues(id);
		return new Promise((resolve, reject) => {
			this.tmQueueService.getQueues().subscribe(data => {
				queues = data.Response.Data;

				if (queues) {
					//if we weren't in a queue and no queue was specified in the URL, then show the selector
					//if (curQueue == null && id == null)
					//	cls.queueSelector(true, null);
					//if we were already in a queue, and we didn't change queues, the load up the current queue
					if (curQueue && (id == null && id == curQueue.ID)) {
						if (!this.deepLinkRedirect()) {
							if (curQueue.DialerType == "Preview" || curQueue.DialerType == "Power" || curQueue.DialerType == "Keypad") {
								var getNextCall = function () {
									//get the next item and go there
									this.tmQueueService.GetNextActionItem(curQueue.ID).subscribe(response => {
										navigateURL = response;
									})
									//im.DataService.instance().GetNextActionItem({ queueID: curQueue.ID }, function (response) {
									//	cls.redirect('Dialog/' + response);
									//}, function (errorCode, message) {
									//	im.UIAlert.open("Unable to get the next record: " + message);
									//});
								}
								if (curQueue.DialerType == "Preview" || curQueue.DialerType == "Keypad")//|| cls.cl().main().mainController().userHasBeenWarned())
									getNextCall();
								else {
									//	cls.cl().main().mainController().showAutomationWarning(getNextCall);
								}
							} else if (curQueue.DialerType == "Predictive" || curQueue.DialerType == "Progressive") {
								//cls.redirect('Dialog/' + curQueue.ID + '-auto');
								navigateURL = curQueue.ID + '-auto';
							} else if (curQueue.DialerType == "AutomatedInbound") {
								//cls.redirect('Dialog/' + curQueue.ID + '-inbound_auto');
								navigateURL = curQueue.ID + '-inbound_auto';
							} else if (curQueue.Type != "Search") {
								//cls.view().refreshTable((lastParams && lastParams.searchValue) ? lastParams.searchValue : null);
							}
						}
					} else {
						//cls.view().clear();
						if (id != null) {
							//resolve(this.updateData(id, null, null));
							this.updateData(id, null, null).then(res => {
								resolve(res);
							});

						}


					}
					if (curQueue) {
						//cls.showAddRecordBtn((curQueue.Type == "Outbound" || curQueue.Type == "Blended") && curQueue.EnableAddRecord);
						//cls.showCreateCaseBtn((curQueue.Type == "Outbound" || curQueue.Type == "Blended") && curQueue.EnableCaseCreation);
						//cls.cl().main().mainController().showDashboardBtn(true);
						//cls.cl().main().mainController().showQueueSelector(queues.length >= 2);
						//cls.cl().main().mainController().queueType(curQueue.Type);
						//cls.cl().main().mainController().setQueueInfo(curQueue.Name, curQueue.ID, curQueue.DialerType, curQueue.PhoneClient);
						//if (curQueue.Type == "Search") {
						//	cls.view().resetSearch();
						//}
					}
				} else {
					this.getqueues();
					//dataService.GetQueues(function (data) {
					//	queues = data;
					//cls.cl().main().mainController().showQueueSelector(data.length >= 2 || ((isAuditor || isManager || isStaffer) && data.length >= 1));
					//cls.cl().main().mainController().userHasQueues(data.length > 0);
					//if (data.length == 0 && (isAuditor || isManager || isStaffer)) {
					//	cls.MVC().redirect('/Console');
					//} else {
					//	cls.queueSelector(curQueue == null, id);
					//	//cls.updateData(id);
					//}
					//});
				}

				//return navigateURL;
				//resolve(navigateURL)

			})
			//resolve(navigateURL);
		});
	}//);
	//}
	getqueues = function (id) {
		this.tmQueueService.getQueues().subscribe(data => {
			queues = data.Response.Data;

			if (queues) {
				//if we weren't in a queue and no queue was specified in the URL, then show the selector
				//if (curQueue == null && id == null)
				//	cls.queueSelector(true, null);
				//if we were already in a queue, and we didn't change queues, the load up the current queue
				if (curQueue && (id == null || id == curQueue.ID)) {
					if (!this.deepLinkRedirect()) {
						if (curQueue.DialerType == "Preview" || curQueue.DialerType == "Power" || curQueue.DialerType == "Keypad") {
							//var getNextCall = function () {
							//	//get the next item and go there
							//	this.tmQueueService.GetNextActionItem(curQueue.ID).subscribe(response => {
							//		navigateURL = response;
							//	})
							//	//im.DataService.instance().GetNextActionItem({ queueID: curQueue.ID }, function (response) {
							//	//	cls.redirect('Dialog/' + response);
							//	//}, function (errorCode, message) {
							//	//	im.UIAlert.open("Unable to get the next record: " + message);
							//	//});
							//}
							if (curQueue.DialerType == "Preview" || curQueue.DialerType == "Keypad")//|| cls.cl().main().mainController().userHasBeenWarned())
								this.getNextCall(curQueue.ID);
							else {
								//	cls.cl().main().mainController().showAutomationWarning(getNextCall);
							}
						} else if (curQueue.DialerType == "Predictive" || curQueue.DialerType == "Progressive") {
							//cls.redirect('Dialog/' + curQueue.ID + '-auto');
							navigateURL = curQueue.ID + '-auto';
						} else if (curQueue.DialerType == "AutomatedInbound") {
							//cls.redirect('Dialog/' + curQueue.ID + '-inbound_auto');
							navigateURL = curQueue.ID + '-inbound_auto';
						} else if (curQueue.Type != "Search") {
							//cls.view().refreshTable((lastParams && lastParams.searchValue) ? lastParams.searchValue : null);
						}
					}
				} else {
					//cls.view().clear();
					if (id != null)
						this.updateData(id, null, null);
				}
				if (curQueue) {
					//cls.showAddRecordBtn((curQueue.Type == "Outbound" || curQueue.Type == "Blended") && curQueue.EnableAddRecord);
					//cls.showCreateCaseBtn((curQueue.Type == "Outbound" || curQueue.Type == "Blended") && curQueue.EnableCaseCreation);
					//cls.cl().main().mainController().showDashboardBtn(true);
					//cls.cl().main().mainController().showQueueSelector(queues.length >= 2);
					//cls.cl().main().mainController().queueType(curQueue.Type);
					//cls.cl().main().mainController().setQueueInfo(curQueue.Name, curQueue.ID, curQueue.DialerType, curQueue.PhoneClient);
					//if (curQueue.Type == "Search") {
					//	cls.view().resetSearch();
					//}
				}
			} else {
				this.getqueues();
				//dataService.GetQueues(function (data) {
				//	queues = data;
				//cls.cl().main().mainController().showQueueSelector(data.length >= 2 || ((isAuditor || isManager || isStaffer) && data.length >= 1));
				//cls.cl().main().mainController().userHasQueues(data.length > 0);
				//if (data.length == 0 && (isAuditor || isManager || isStaffer)) {
				//	cls.MVC().redirect('/Console');
				//} else {
				//	cls.queueSelector(curQueue == null, id);
				//	//cls.updateData(id);
				//}
				//});
			}

			return navigateURL;
		})
	}
	deepLinkRedirect = function () {
		//	var cacheKey = '';// cls.Security().user().UserID + "#";
		//var deepLink = $.cookie(cacheKey + 'DeepLink');
		//if (typeof deepLink == 'undefined') {
		return false;
		//}
		////cls.redirect(deepLink);
		//$.removeCookie(cacheKey + 'DeepLink');
		//return true;
	}

	updateData = function (id, type, skipFinish) {
		//if (id === undefined)
		//	id = cls.appParams().currentQueue;
		return new Promise((resolve, reject) => {
			this.tmQueueService.setCurrentQueue(id).subscribe(data => {
				//console.log("setCurrentQueue response", data);

				//dataService.SetCurrentQueue({ id: id }, function (reloadRequired) {
				//	if (reloadRequired) {
				//		//if we're switching to a different queue with a different configuration then we have to reload the page so the dynamic viewdefs will be regenerated
				//		reloading = true;
				//		window.location.reload();
				//	} else {
				//preload the UserInfo, Survey, and Scoring ViewDefs
				//if (!dynamicViewDefsLoaded) {
				//	a5.cl.initializers.dom.ResourceCache.instance().load("/Content/views/DynamicViewDefs.xml");
				//	dynamicViewDefsLoaded = true;
				//}
				//call back into updateData
				if (skipFinish !== true)
					resolve(

						this.finishUpdateData(id, type)

					);
				//	}
			})
		});
	}

	finishUpdateData = function (id, type) {
		//if (cls.appParams().queueBuildOptions) {
		//	type = cls.appParams().queueBuildOptions.type;
		//	//set priority from options.priority value
		//	curQueuePriority = cls.appParams().queueBuildOptions.priority;
		//	cls.appParams().queueBuildOptions = null;
		//}
		//if (!type)
		//	type = QueueController.QUEUE_TYPE_ALL;
		curQueueDisplayType = type;
		//cls.view().setActiveQueueView(type, curQueuePriority);
		recordLocks = {};
		for (var i = 0, l = queues.length; i < l; i++) {
			if (queues[i].ID == id) {
				curQueue = queues[i];
				//if (!this.deepLinkRedirect()) {
				if (curQueue && (curQueue.DialerType == "Preview" || curQueue.DialerType == "Power") || curQueue.DialerType == "Keypad") {

					if (curQueue.DialerType == "Preview" || curQueue.DialerType == "Keypad")//|| cls.cl().main().mainController().userHasBeenWarned())
					{ 
						//this.getNextCall(curQueue.ID);
						return new Promise((resolve, reject) => {
							this.tmQueueService.GetNextActionItem(curQueue.ID).subscribe(response => {
								navigateURL = response.Response.Data;
							//navigateURL = '2413-auto';
								this.setQueueInfo(curQueue.Name, curQueue.ID, curQueue.DialerType, curQueue.PhoneClient, navigateURL, curQueue.Type);
								//return dataQueueInfo;
								resolve(dataQueueInfo);
							})
						});
						
						//}
						
					}
					else {
						//cls.cl().main().mainController().showAutomationWarning(getNextCall);
					}
				} else if (curQueue.DialerType == "Predictive" || curQueue.DialerType == "Progressive") {
					if (reloading)
						return;
					//cls.redirect('Dialog/' + curQueue.ID + '-auto');
					navigateURL = curQueue.ID + '-auto';
					this.setQueueInfo(curQueue.Name, curQueue.ID, curQueue.DialerType, curQueue.PhoneClient, navigateURL, curQueue.Type);
					//}
					return dataQueueInfo;
				} else if (curQueue.DialerType == "AutomatedInbound") {
					//cls.redirect('Dialog/' + curQueue.ID + '-inbound_auto');
					navigateURL = curQueue.ID + '-inbound_auto';
					this.setQueueInfo(curQueue.Name, curQueue.ID, curQueue.DialerType, curQueue.PhoneClient, navigateURL, curQueue.Type);
					//}
					return dataQueueInfo;
				} else {
					//cls.cl().main().mainController().lockStatus({
					//	label: 'In Queue',
					//	value: 6
					//});
					//cls.showAddRecordBtn((curQueue.Type == "Outbound" || curQueue.Type == "Blended") && curQueue.EnableAddRecord);
					//cls.showCreateCaseBtn((curQueue.Type == "Outbound" || curQueue.Type == "Blended") && curQueue.EnableCaseCreation);
					//cls.cl().main().mainController().setQueueInfo(curQueue.Name, curQueue.ID, curQueue.DialerType, curQueue.PhoneClient);

					lastParams = null;
					//if we don't already have a list of columns for this queue, get it now
					//var finishUpdate = function () {
					//	cls.view().drawTable(columns[id], function () {
					//		if (curQueue.Type == "Inbound" || curQueue.Type == "TextChat" || curQueue.Type == "VideoChat")
					//			$('.dataTables_filter', cls.view()._cl_viewElement).text('');
					//	});
					//	cls.view().queueType(curQueue.Type);
					//	cls.view().table().filterDataFunc(eGetFilterOptions);
					//}
					//if (columns[id])
					//	finishUpdate();
					//else dataService.GetQueueColumns({
					//	queueID: id
					//}, function (cols) {
					//	var theseCols = [{
					//		label: "ID",
					//		name: "ID",
					//		hide: true
					//	}], x, y, thisCol;
					//	for (x = 0, y = cols.length; x < y; x++) {
					//		thisCol = cols[x];
					//		theseCols.push({
					//			label: thisCol.Label,
					//			name: thisCol.Name,
					//			searchable: thisCol.Searchable,
					//			sortable: thisCol.Sortable,
					//			showFilter: thisCol.Filterable,
					//			width: thisCol.Width,
					//			dataType: thisCol.DataType
					//		});
					//	}
					//	columns[id] = theseCols;
					//	finishUpdate();
					//});
					//if (curQueue.AutoUpdate === true)
					//	updateInterval = setInterval(forceTableUpdate, 20000);
					this.setQueueInfo(curQueue.Name, curQueue.ID, curQueue.DialerType, curQueue.PhoneClient, navigateURL, curQueue.Type);
					//}
					return dataQueueInfo;
				}
				
				//break;
			}
		}
		//cls.cl().main().mainController().showInboundStatus(false);
		//cls.cl().main().mainController().showOutboundStatus(false);
		//if (curQueue == null) {
		//	cls.queueSelector(true);
		//} else {
		//if (curQueue.Type == "Inbound" || curQueue.Type == "Blended" || curQueue.Type == "TextChat" || curQueue.Type == "VideoChat" || (curQueue.Type == "Outbound" && curQueue.LinkedQueueCount != 0))
		//	cls.cl().main().mainController().showInboundStatus(true, curQueue.ID);
		//else if (curQueue.Type == "Outbound" || curQueue.Type == "Search")
		//	cls.cl().main().mainController().showOutboundStatus(true);
		//cls.view().visible(true);
	}
	getNextCall = function (queueID) {
		//get the next item and go there
		return new Promise((resolve, reject) => {
			this.tmQueueService.GetNextActionItem(queueID).subscribe(response => {
				navigateURL = response.Data;
				resolve(response.Data);
			})
		});
		//im.DataService.instance().GetNextActionItem({ queueID: curQueue.ID }, function (response) {
		//	cls.redirect('Dialog/' + response);
		//}, function (errorCode, message) {
		//	im.UIAlert.open("Unable to get the next record: " + message);
		//});
	}
	setQueueInfo = function (name, id, dialerType, softPhoneClient, navigateurl, inboundType) {
		var softPhoneClientChanged = false;
		var dataInfo: any = {};
		//softPhoneCallback = callback;
		dataInfo.queueName = name;
		dataInfo.automatedQueue = dialerType == "Preview" || dialerType == "Power" || dialerType == "Progressive" || dialerType == "Predictive" || dialerType == "AutomatedInbound" || dialerType == "AutomatedExternal" || dialerType == "Keypad";
		//progressiveQueue = dialerType == "Progressive";
		//predictiveQueue = dialerType == "Predictive";
		dataInfo.automatedInbound = dialerType == "AutomatedInbound";
		//automatedExternal = dialerType == "AutomatedExternal";
		//manualExternal = dialerType == "ManualExternal";
		//keypadQueue = dialerType == "Keypad";
		dataInfo.navigateURL = navigateurl;
		dataInfo.dialerType = dialerType;
		dataInfo.interactionType = (typeof inboundType == 'undefined' || inboundType == null) ? this.interactionType : inboundType;
		dataQueueInfo = dataInfo;
		//if (typeof id != 'undefined') {
		//    if (queueID != id)
		//        userHasBeenWarned = false;
		//    if ((activeController != "Console") || (activeController == "Console" && id == 0))
		//        phoneController.currentQueue(id);
		//    queueID = id;
		//}

		//if (typeof softPhoneClient != 'undefined') {
		//    if (phoneClient != softPhoneClient || sipAddress == null) {
		//        softPhoneClientChanged = true;
		//        phoneClient = softPhoneClient;
		//        if (!cls.QBRApp().getClientAppParams().UseSoftPhone) {
		//            im.UserService.instance().UserHasGrant({ grantName: 'SoftphoneOnly' }, function (hasGrant) {
		//                cls.softPhoneOnly(hasGrant);
		//                if (hasGrant || forceSoftPhone) {
		//                    cls.QBRApp().setClientAppParam('UseSoftPhone', true, true);
		//                }
		//                cls.phoneNumberSetup(softPhoneClientChanged);
		//            });
		//            return;
		//        }
		//    }
		//}

		//cls.previewMessageReset();
		//cls.phoneNumberSetup(softPhoneClientChanged);

		//return dataQueueInfo;
	}
}

//}